import React, { PropsWithChildren } from "react";
import { IconButton, Tooltip } from "@material-ui/core";

import { CircleIcon } from "../../../../../../../../../../components/icon/circle-icon/circle-icon.component";

import { FlyerDetailPageDetailSideMenuIconProps } from "./flyer-detail-page-detail-side-menu-icon.props";
import { useToolTipStyles } from "./flyer-detail-page-detail-side-menu-icon.styles";

export const FlyerDetailPageDetailSideMenuIcon = (
  props: PropsWithChildren<FlyerDetailPageDetailSideMenuIconProps>
) => {
  const classes = useToolTipStyles();

  return (
    <Tooltip arrow classes={classes} placement="left" title={props.tooltip}>
      <IconButton
      onClick={props.onClick} 
      title={props.tooltip}
      >
        <CircleIcon 
          className={props.className} 
          style={{ margin: "0" }}
          variant={props.variant}>
          {props.children}
        </CircleIcon>
      </IconButton>
    </Tooltip>
  );
};
